module.exports = __webpack_public_path__ + "static/people_pop24-47b73c17f6964b010611926f2632153f.png";